import type { WsEvent } from '@most/ws-client';

/**
 * A one-file event bus bridging the app's single WS mount (App.tsx) to the chat widget.
 *
 * The socket is mounted once in BuyerApp; the call engine lives in SupportChat, which may
 * mount later. Rather than threading a ref through the tree, App forwards `chat.*` /
 * `call.*` frames here and the widget subscribes. Frames stay thin — this bus carries the
 * same {type, id} nudge the wire did, never data.
 */
type Listener = (event: WsEvent) => void;

const listeners = new Set<Listener>();

export const chatEvents = {
  emit(event: WsEvent): void {
    for (const l of listeners) l(event);
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
